module.exports = __webpack_public_path__ + "static/img/live-bg-4.debb03e6.jpg";